import React, { useContext } from 'react'
import Prop from './Prop'
import { ICON_TYPES } from '../constantes/iconos.ts'
import styled, { keyframes } from 'styled-components'
import Titulo from './Titulo.jsx'
import Equipo from '../imagenes/lacrosse.jpeg'
import video from '../videos/videoLacrosse.mp4'
import { ContextoDispositivo } from '../contextos/Dispositivo.js'

const Lacrosse = () => {
    const { dispositivo } = useContext(ContextoDispositivo)
    return (
        <>
            <Prop titulo='LACROSSE CONEXION' icono={ICON_TYPES.LACROSSE} />
            <Section>
                <Resumen>
                    <Titulo titulo='Que Es Lacrosse Conexion' color='white' />
                    <p style={{ fontSize: '20px', textAlign: 'center' }}>Tenemos un trabajo semanal con la con la práctica del deporte lacross es un deporte donde todos los niños trabajan y no solo aprenden del deporte sino de la convivencia entre ellos del respeto del saber aceptar a los demás</p>
                </Resumen>
                <Contenedor grande={dispositivo}>
                    <img style={{ height: '100%', width: '100%' }} src={Equipo} alt="equipo" />
                </Contenedor>
            </Section>
            <div style={{ height: '200px', width: '100vw' }} />
            <Section fondo='var(--secundary)'>
                <video src={video} type='video/mp4' width='100%' height='100%' autoPlay loop controls >
                </video>
            </Section>
        </>
    )
}

const animacion = keyframes`
    0%{transform: translateY(-15px)}
    50%{transform: translateY(15px)}
    100%{transform: translateY(-15px)}
`

const Section = styled.section`
    background-color: ${props => props.fondo};
    width: 100vw;
    height: 500px;
    padding: 30px 0 30px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
`

const Resumen = styled.article`
    justify-content: space-around;
    align-items: center;
    background-color: var(--primary);
    width: max(500px, 60%);
    height: max-content;
    box-shadow: 4px 4px 20px #000;
    padding: 50px;
    color: white;
    gap: 20px;
`

const Contenedor = styled.div`
    background-color: blue;
    height: ${props => props.grande ? '300px' : '200px'};
    ${props => props.grande ? '' : 'transform: translateY(-100px);'}
    width: 300px;
    animation-name: ${animacion};
    animation-duration: 5s;
    animation-iteration-count: infinite;
    margin: auto;
    transform: translateY(100%);
    margin-top: 30px;
    box-shadow: 4px 4px 20px #000;

`

export default Lacrosse